import IStorage, {EverflowStore} from "./interface"

const KEY = "pb-everflow"

class Storage implements IStorage {
  async get(): Promise<EverflowStore> {
    const raw = window.localStorage.getItem(KEY)
    let data: EverflowStore = {}
    try {
      data = JSON.parse(raw || "{}")
    } catch (e) {
      /* no-op */
    }

    return data
  }

  async set(data: EverflowStore) {
    const str = JSON.stringify(data)
    window.localStorage.setItem(KEY, str)
  }
}

const everflowStorage = new Storage()

export default everflowStorage
